import {
	IMAGES_URL,
	ISubNavigationItem,
	PROJECT_NAME,
	PROJECTS_NAVIGATION_ITEMS,
} from "data/constants";
import emptyPlayer from "assets/img/empty_player.png";
import {find, filter} from "lodash";
import {IPlayer} from "data/stores/players/players.store";
import {ISessionWithPick} from "data/stores/rounds/rounds.store";

export const getOpenState = (value: boolean) => (value ? "open" : "closed");

export const getPlayerHeadshot = (playerId: number) => {
	return playerId ? `${IMAGES_URL}players/${playerId}.png` : emptyPlayer;
};

export const getPlayerFlag = (country: string) => {
	return `${IMAGES_URL}flags/${country}.png`;
};

export const getProjectNavigation = () => {
	const activeProject = find(
		PROJECTS_NAVIGATION_ITEMS,
		({projectName}) => projectName === PROJECT_NAME
	);
	const filteredProjects = filter(
		PROJECTS_NAVIGATION_ITEMS.filter((it) => !it.hidden),
		({projectName}) => projectName !== PROJECT_NAME
	);

	return {
		name: activeProject?.name,
		to: "/",
		subItems: filteredProjects,
	} as ISubNavigationItem;
};

export const numberOrDashes = (value?: string | number | null) => value || "--";

export const findLabelByValue = (
	options: {
		label: string;
		value: string;
	}[],
	value: string
) => {
	const option = options.find((option) => option.value === value);
	return option?.label || "";
};

export const getPlayerShortName = (player?: IPlayer) => {
	if (!player) {
		return "";
	}

	return `${player.firstName.charAt(0)}. ${player.lastName}`;
};

export const getIsRoundFoursomes = (round: ISessionWithPick | null) => {
	if (!round) {
		return false;
	}

	const name = round.name.toLowerCase();

	return name.includes("foursomes");
};

export const convertYardToFeet = (value: number) => {
	return value * 3;
};

export const convertYardToFeetAndInches = (value: number) => {
	const feet = Math.floor(convertYardToFeet(value));
	const inches = Math.floor((value * 3 - feet) * 12);

	return `${feet}ft ${inches}in`;
};
